/* unplugin-vue-components disabled */import { render } from "./usage-reports.vue?vue&type=template&id=62732f4f&scoped=true"
import script from "./usage-reports.vue?vue&type=script&lang=js"
export * from "./usage-reports.vue?vue&type=script&lang=js"

import "./usage-reports.vue?vue&type=style&index=0&id=62732f4f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62732f4f"],['__file',"src/pages/tenant/settings/analytics/usage-reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62732f4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62732f4f', __exports__)) {
    api.reload('62732f4f', __exports__)
  }
  
  module.hot.accept("./usage-reports.vue?vue&type=template&id=62732f4f&scoped=true", () => {
    api.rerender('62732f4f', render)
  })

}


export default __exports__